import { z } from 'zod'

export const orderResponseSchema = z.object({
  id: z.string().guid(),
  tbankOrderId: z.string(),
  executionReportStatus: z.number().int(),
  statusName: z.string(),
  lotsRequested: z.number().int(),
  lotsExecuted: z.number().int(),
  figi: z.string().nullable(),
  ticker: z.string().nullable(),
  instrumentUid: z.string().nullable(),
  direction: z.number().int(),
  directionName: z.string(),
  orderType: z.number().int(),
  orderTypeName: z.string(),
  initialOrderPrice: z.number(),
  executedOrderPrice: z.number(),
  orderDate: z.coerce.date(),
  // when our stored copy last changed; for a terminal order this is its completion time
  updatedAt: z.coerce.date(),
  currency: z.string().nullable(),
  currentPrice: z.number().nullable(),
  lotSize: z.number().int().nullable(),
  // T-Bank instrumentType (e.g. 'bond'), set by order-list enrichment from the instrument cache;
  // absent or null when the instrument could not be resolved
  instrumentType: z.string().nullable().optional(),
})

export type OrderResponseDto = z.infer<typeof orderResponseSchema>
